import { render, staticRenderFns } from "./Tr.vue?vue&type=template&id=9be65a84&"
import script from "./Tr.vue?vue&type=script&lang=js&"
export * from "./Tr.vue?vue&type=script&lang=js&"
import style0 from "./Tr.vue?vue&type=style&index=0&id=9be65a84&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports